import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=8e4d0e4a&scoped=true&"
import script from "./ProfileForm.vue?vue&type=script&lang=js&"
export * from "./ProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileForm.vue?vue&type=style&index=0&id=8e4d0e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4d0e4a",
  null
  
)

export default component.exports